/* Phone size; .large grows from 1024 px. dubai's lockup, in Playfair Display. */
.lockup {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  color: var(--brand-ink);
}

.mark {
  width: 34px;
  height: 34px;
}

.name {
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 21px;
  line-height: 1;
  letter-spacing: 0.09em;
  padding-left: 0.09em;
}

.sub {
  align-self: stretch;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 8.5px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.32em;
  white-space: nowrap;
  color: var(--brand);
}

.rule {
  flex: 1;
  min-width: 6px;
  height: 1px;
  background: var(--brand-gold);
}

/* The tracking trails the last letter: pull the right rule back so TO DO sits centred. */
.rule:last-child {
  margin-left: -0.32em;
}

@media (min-width: 1024px) {
  .large .mark {
    width: 44px;
    height: 44px;
  }

  .large .name {
    font-size: 27px;
  }

  .large .sub {
    gap: 8px;
    font-size: 10px;
  }
}
